export const TABS = {
    LEASING: 'leasing',
    RESIDENT: 'resident',
  };